import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Engine } from '@telespot/domain';

export interface AlgorithmCompatibilityInfo {
  outputLabels: Set<string>;
  engine: Engine | undefined;
  deprecated: boolean;
}

interface AlgorithmDetailStateModel {
  id: string | undefined;
  compatibilityInfo: AlgorithmCompatibilityInfo | undefined;
  error: string | null;
}

const INITIAL_STATE: AlgorithmDetailStateModel = {
  id: undefined,
  compatibilityInfo: undefined,
  error: null,
};

@Injectable()
export class AlgorithmDetailState extends ComponentStore<AlgorithmDetailStateModel> {
  constructor() {
    super({ ...INITIAL_STATE });
  }

  // ============================================================================
  // Selectors
  // ============================================================================

  public readonly id$ = this.select((state) => state.id);
  public readonly compatibilityInfo$ = this.select((state) => state.compatibilityInfo);
  public readonly error$ = this.select((state) => state.error);

  // ============================================================================
  // Updaters
  // ============================================================================

  public readonly setAlgorithm = this.updater(
    (
      state,
      algorithm: {
        id: string;
        outputLabels: Set<string>;
        engine: Engine | undefined;
        deprecated: boolean;
      }
    ) => ({
      id: algorithm.id,
      compatibilityInfo: {
        outputLabels: algorithm.outputLabels,
        engine: algorithm.engine,
        deprecated: algorithm.deprecated,
      },
      error: null,
    })
  );

  public readonly setError = this.updater((state, error: string | null) => ({ ...state, error }));

  public readonly reset = this.updater(() => ({ ...INITIAL_STATE }));
}
